import 'css-chunksrc/client/pages/projectPage/kanbanPage/toolbar/statusFilter/styles.scss';export default {
  "statusFilter": "_statusFilter_1irwz_1",
  "rootClassName": "_rootClassName_1irwz_9",
  "input": "_input_1irwz_13",
  "openedInput": "_openedInput_1irwz_30",
  "iconOpen": "_iconOpen_1irwz_36",
  "icon": "_icon_1irwz_36",
  "listRoot": "_listRoot_1irwz_53",
  "list": "_list_1irwz_53",
  "title": "_title_1irwz_69",
  "selectedStatuses": "_selectedStatuses_1irwz_75",
  "checkbox": "_checkbox_1irwz_84",
  "checked": "_checked_1irwz_98",
  "item": "_item_1irwz_113",
  "selectAll": "_selectAll_1irwz_124",
  "selected": "_selected_1irwz_75"
};